var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSmallAggregate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 15,
    viewBox: "0 0 13 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.44147 6.05511L6.37512 0.974121H0.507812L3.44147 6.05511Z",
    fill: "#989898"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.44147 14.524L6.37512 9.44299H0.507812L3.44147 14.524Z",
    fill: "#989898"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.30866 6.05511L12.2423 0.974121H6.375L9.30866 6.05511Z",
    fill: "#989898"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.30866 14.524L12.2423 9.44299H6.375L9.30866 14.524Z",
    fill: "#989898"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmallAggregate);
export default __webpack_public_path__ + "static/media/smallAggregate.464a4e61664df4300ee04f895e40b6c2.svg";
export { ForwardRef as ReactComponent };